<template>
    <div class="left-banner">
        <div class="list-title">
            <div class="lang-title">{{ $t("zhiji.common.language") }}</div>
            <div>{{ $t("zhiji.game.contentBase") }}</div>
        </div>
        <Language @langSelect="langSelect" :currentLang="currentLang" />
    </div>
</template>

<script>
import Language from "./Language";
import { isPubg } from "@/views/zhiji/js/lib/businessCheck.js";

export default {
    name: "LeftBanner",
    props: ["currentLang"],
    components: {
        Language
    },
    methods: {
        langSelect(data) {
            this.$emit("langSelect", data);
        }
    },
    mounted() {
        const gameId = window.localStorage.getItem("gameId");
        const pubg = isPubg();
        if (pubg && gameId != "80002") {
            const gameInfo = { gameId: "80002", gameName: "Content Base" };
            this.$store.commit("zhiji/switchCurrentGame", gameInfo);
        } else if (!pubg) {
            this.$router.push("/");
        }
    }
};
</script>

<style lang="scss" scoped>
.left-banner {
    width: 260px;
    border-right: 1px solid #d8e4f0;
    flex-grow: 0;
    flex-shrink: 0;
    height: 100%;
    overflow: auto;
    background: #f2f7fb;

    .list-title {
        font-size: 14px;
        display: flex;
        align-items: center;
        padding: 15px 16px 12px 16px;
        font-weight: bold;
        justify-content: space-between;
        border-bottom: 1px solid #d8e4f0;

        .lang-title {
            font-weight: 700;
            width: 55%;
        }

        .game-info {
            position: relative;
            font-size: 14px;
            height: 18px;
            font-weight: initial;
            flex: 1;
        }
    }
}
</style>
